"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var utils_1 = require("./utils");
var classnames_1 = __importDefault(require("classnames"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var ProgressComponent = function ProgressComponent(props) {
  var _a, _b;
  var percent = props.percent,
    _c = props.type,
    type = _c === void 0 ? 'info' : _c,
    _d = props.size,
    size = _d === void 0 ? 'normal' : _d,
    strokeWidth = props.strokeWidth,
    _e = props.radius,
    radius = _e === void 0 ? 'full' : _e,
    strokeColor = props.strokeColor,
    loading = props.loading,
    lineClassName = props.lineClassName,
    trackProps = props.trackProps,
    lineProps = props.lineProps,
    animate = props.animate;
  var typeColor = {
    info: 'var(--odc-blue-06)',
    warning: 'var(--odc-orange-06)',
    danger: 'var(--odc-red-06)',
    success: 'var(--odc-green-06)'
  };
  var fillColor = '';
  if (strokeColor) {
    if (typeof strokeColor === 'string') {
      fillColor = strokeColor;
    } else {
      fillColor = "linear-gradient(to right, ".concat(strokeColor.from, ", ").concat(strokeColor.to, ")");
    }
  } else {
    fillColor = typeColor[type];
  }
  var percentStyle = (_a = {
    width: "".concat((0, utils_1.validProgress)(percent), "%"),
    height: strokeWidth || (size === 'small' ? 4 : 8)
  }, _a['--odc-progress-line-width'] = "".concat((0, utils_1.validProgress)(percent), "%"), _a);
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-progress w-full', (_b = {}, _b["odc-progress-".concat(type)] = type, _b['odc-progress-loading'] = loading, _b['odc-progress-animate'] = animate, _b)),
    supportAllEvents: true
  }, ProgressComponent), {
    clipContent: true,
    useClassName: false,
    radius: radius,
    bg: loading ? 'transparent' : 'gray-8'
  }, trackProps), react_1["default"].createElement(odc_frame_1["default"], __assign({
    className: (0, classnames_1["default"])('odc-progress-line', {
      'odc-progress-line-animate': animate
    }, lineClassName),
    fill: fillColor,
    useClassName: false,
    style: percentStyle
  }, lineProps)));
};
(0, spaui_utils_1.setComponentMark)(ProgressComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(ProgressComponent);